import(/* webpackMode: "eager", webpackExports: ["AppShell"] */ "/vercel/path0/src/components/layout/WordAppShellEntry.tsx");
